// Pathway persistence helpers.
//
// A user chooses a pathway once (Investor or Company) and that choice must
// propagate through onboarding, opportunity creation, guided trials and
// analytics without re-prompting. We persist:
//   1. sessionStorage — for the current tab/session (survives navigation).
//   2. URL query param  ?path=investor|company on route boundaries so a link
//      shared between tabs / devices carries the intent explicitly.
//
// The server owns the durable copy (users.path_intent, opportunities.pathway,
// test_events.path). This module is purely for client-side propagation.

export const PATHWAYS = { investor: "investor", company: "company" };
const KEY = "impactvest_pathway";

export function setPathway(p) {
  if (!p || (p !== "investor" && p !== "company")) return;
  try { sessionStorage.setItem(KEY, p); } catch { /* no-op */ }
}

export function getPathway() {
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get("path");
    if (q === "investor" || q === "company") {
      sessionStorage.setItem(KEY, q);
      return q;
    }
    return sessionStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function clearPathway() {
  try { sessionStorage.removeItem(KEY); } catch { /* no-op */ }
}

// Build a URL that preserves the pathway query so it flows into the next step.
export function withPathway(href, pathway) {
  if (!pathway) return href;
  const [base, hash = ""] = href.split("#");
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}path=${pathway}${hash ? "#" + hash : ""}`;
}
